import { Box, SvgIcon } from "@mui/material";

export const InfoIcon = (props) => {
  const { pdleft, pdbottom, pdright, pdtop, ...otherProps } = props;

  return (
    <Box
      sx={{
        display: "flex",
        cursor: "pointer",
        paddingLeft: pdleft ? `${pdleft}px` : "10px",
        paddingBottom: pdbottom ? `${pdbottom}px` : "1px",
        paddingRight: pdright ? `${pdright}px` : "1px",
        paddingTop: pdtop ? `${pdtop}px` : "1px",
      }}
      {...otherProps}
    >
      <InfomationIcon />
    </Box>
  );
};

export const InfomationIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd" transform="translate(1 1)">
        <g fill="#ADADAD" mask="url(#prefix__b)">
          <path
            id="prefix__a"
            d="M6.333 10.333h1.334v-4H6.333v4zM7 .333C3.32.333.333 3.32.333 7c0 3.68 2.987 6.667 6.667 6.667 3.68 0 6.667-2.987 6.667-6.667C13.667 3.32 10.68.333 7 .333zm0 12C4.06 12.333 1.667 9.94 1.667 7 1.667 4.06 4.06 1.667 7 1.667c2.94 0 5.333 2.393 5.333 5.333 0 2.94-2.393 5.333-5.333 5.333zM6.333 5h1.334V3.667H6.333V5z"
          />
        </g>
      </g>
    </svg>
  );
};

export const InformationIconFilled = (props) => (
  <SvgIcon {...props} viewBox="0 0 21 21" fill="none">
    <path
      d="M8.8 5.6H7.2V4H8.8M8.8 12H7.2V7.2H8.8M8 0C6.94943 0 5.90914 0.206926 4.93853 0.608964C3.96793 1.011 3.08601 1.60028 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.08601 14.3997 3.96793 14.989 4.93853 15.391C5.90914 15.7931 6.94943 16 8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 6.94943 15.7931 5.90914 15.391 4.93853C14.989 3.96793 14.3997 3.08601 13.6569 2.34315C12.914 1.60028 12.0321 1.011 11.0615 0.608964C10.0909 0.206926 9.05058 0 8 0Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const WarningIcon = () => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17">
      <g fill="none" fillRule="evenodd" transform="translate(1 1.84)">
        <g fill="#FF004D" mask="url(#prefix__b)">
          <path
            id="prefix__a"
            d="M7 .333C3.32.333.333 3.32.333 7c0 3.68 2.987 6.667 6.667 6.667 3.68 0 6.667-2.987 6.667-6.667C13.667 3.32 10.68.333 7 .333zm.667 10H6.333V9h1.334v1.333zm0-2.666H6.333v-4h1.334v4z"
          />
        </g>
      </g>
    </svg>
  );
};

export const InfoActiveIcon = (props) => {
  const { pdleft, pdbottom, pdright, pdtop, ...otherProps } = props;

  return (
    <Box
      sx={{
        display: "flex",
        cursor: "pointer",
        paddingLeft: pdleft ? `${pdleft}px` : "10px",
        paddingBottom: pdbottom ? `${pdbottom}px` : "1px",
        paddingRight: pdright ? `${pdright}px` : "1px",
        paddingTop: pdtop ? `${pdtop}px` : "1px",
      }}
      {...otherProps}
    >
      <ActiveIcon />
    </Box>
  );
};

const ActiveIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd" transform="translate(1 1)">
        <g fill="#FFF" mask="url(#prefix__b)">
          <path
            id="prefix__a"
            d="M7 .333C3.32.333.333 3.32.333 7c0 3.68 2.987 6.667 6.667 6.667 3.68 0 6.667-2.987 6.667-6.667C13.667 3.32 10.68.333 7 .333zm.667 10H6.333v-4h1.334v4zm0-5.333H6.333V3.667h1.334V5z"
          />
        </g>
      </g>
    </svg>
  );
};
